import { GetServerSideProps } from "next";
import Head from "next/head";
import { StrapiTermsAndConditions } from "~/shared-types";
import { findSingleType } from "~/strapi/api";
import { handleRequestError } from "~/utils/rollbar";
import Richtext from "~/components/Richtext";
import SingleType from "../SingleType";

type ServerSideProps = {
  page: StrapiTermsAndConditions | null;
};

export const getServerSideProps: GetServerSideProps<ServerSideProps> = async (
  context
) => {
  const page = await findSingleType<StrapiTermsAndConditions>(
    "privacy-policy"
  ).catch(handleRequestError(context.req, null));

  return {
    props: {
      page,
    },
  };
};

export default function PrivacyPolicyPage({ page }: ServerSideProps) {
  return (
    <SingleType>
      <Head>
        <title>Butik Danmark - Privatlivspolitik</title>
        <meta
          name="description"
          content="Alt det gode danske håndværk - samlet ét sted"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <h1 className="uppercase text-3xl mt-20 mb-2 font-bold antialiased tracking-widest text-center">
        Persondatapolitik
      </h1>
      {page?.attributes.content && (
        <SingleType.Content>
          <Richtext content={page.attributes.content} />
        </SingleType.Content>
      )}
    </SingleType>
  );
}
